import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const peertube = defineConnector({
  identifier: "peertube",
  name: "PeerTube",
  tagLine: "Decentralized video hosting platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your PeerTube access token",
      items: [
        {
          kind: "markdown",
          content:
            "Register an application on your PeerTube instance and complete the OAuth flow to get an access token.",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          placeholder: "https://peertube.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your PeerTube instance.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v1/users/me`,
  },
});
